import styled from 'styled-components';

// CONSTANTS
import { WHITE, MAIN_BLACK, GRAY_SUIT, ATHENS_GRAY, PORCELAIN } from '@/constants/colors';

// UTILITY
// import { breakpoints } from '@/utility/breakpoints';
import realBreakpoints from '@/constants/breakpoints';

// STYLES
import { WPContent as WPContentStyles } from '@/styles/wp';

export const WPContent = styled(WPContentStyles)`
  .markdown {
    white-space: normal !important;
  }
  //sports-appp
  .sportsteampage {
    .header-row {
      background: ${MAIN_BLACK};
      .inner-wrapper {
        width: 1140px;
        max-width: 95%;
        margin: 0 auto;
        height: 175px;
        .breadcrubs {
          padding-top: 24px;
          ol {
            padding: 0;
            margin: 0;
          }
          li {
            display: inline-block;
            font-size: 14px;
            color: ${WHITE};
            &.separator {
              color: ${GRAY_SUIT};
              padding: 3px;
              margin-left: 10px;
              margin-right: 10px;
            }
            a {
              color: ${WHITE};
              opacity: 0.6;
            }
            .icon-chevron-right {
              font-size: 8px;
            }
            span {
              color: ${WHITE};
            }
          }
        }
      }
    }
    .logo-and-name {
      text-align: center;
      .logo-wrapper {
        background: ${WHITE};
        box-shadow: 0px 31.4873px 94.4618px rgba(0, 0, 0, 0.1);
        border-radius: 12px;
        width: 264px;
        margin: -135px auto 32px auto;
        @media (max-width: ${realBreakpoints.sm}) {
          margin: -100px auto 32px auto;
        }
        @media (max-width: ${realBreakpoints.xs}) {
          width: 95%;
        }
        img {
          width: 175px;
        }
      }
      h1 {
        font-size: 42px;
        margin: 0 auto 48px;
        font-style: normal;
        font-weight: normal;
        padding: 0;
        @media (max-width: ${realBreakpoints.sm}) {
          margin: 0 auto 24px;
        }
      }
      h2 {
        font-weight: bold;
        font-size: 36px;
        line-height: 36px;
        padding: 0;
        margin: 0 auto 24px;
        @media (max-width: ${realBreakpoints.xs}) {
          margin: 0 auto 12px;
        }
      }
    }
    .all-games-wrapper {
      width: 1140px !important;
      max-width: 95%;
      margin: 0 auto;
      .game-wrapper {
        .inside {
          border-radius: 0px 0px 24px 24px;
          background: ${ATHENS_GRAY};
          height: 100%;
          min-height: 50px;
          box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
          .top-section {
            background: ${MAIN_BLACK};
            border-radius: 24px 24px 0px 0px;
            color: ${WHITE};
            .date-time {
              text-align: center;
              padding: 24px 10px;
              font-size: 14px;
            }
            .matchup {
              text-align: center;
              img {
                width: 107px;
                background: ${WHITE};
                border-radius: 12px;
                box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
                padding: 8px;
              }
              > div {
                display: inline-block;
                text-align: center;
                vertical-align: middle;
                width: 36%;
                margin-bottom: 12px;
              }
              > div.vs {
                display: inline-block;
                text-align: center;
                vertical-align: middle;
                width: 12%;
                font-size: 30px;
                font-weight: 600;
                margin-top: -60px;
              }
              > div p.team {
                font-size: 16px;
                line-height: 16px;
                height: 62px;
              }
            }
          }
        }
      }
      .bottom-section {
        background: ${ATHENS_GRAY};
        border-radius: 0px 0px 24px 24px;
        min-height: 50px;
        .sale-crossout {
          position: relative;
        }

        .sale-crossout::after {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          width: 100%;
          height: 1px;
          background-color: #ff2c4a;
        }
        .collection {
          text-align: center;
          .section-title {
            font-size: 16px;
            font-weight: 600;
            padding: 16px 0 8px;
          }
          > div {
            display: inline-block;
            font-size: 14px;
            padding: 5px;
            a:hover img {
              box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
            }
            img {
              border-radius: 8px;
              background: ${WHITE};
              padding: 5px;
            }
            .more_apps {
              border-radius: 8px;
              background: ${WHITE};
              padding: 5px;
              height: 73px;
              font-weight: bold;
              line-height: 65px;
            }
            p {
              padding: 0;
              line-height: 1;
              font-weight: 600;
            }
          }
          &.stream-on > div {
            width: 30%;
            vertical-align: top;
          }
          &.channels > div {
            width: 24%;
            img {
              padding: 12px;
            }
          }
        }
      }
    }
  }

  .leaguepage {
    background: ${PORCELAIN};
    .all-teams-wrapper,
    .header-row {
      width: 1140px;
      margin: 0 auto;
      max-width: 95%;
      text-align: center;
    }
    .team-wrapper {
      text-align: center;
      img {
        width: 100%;
        background: ${WHITE};
        border-radius: 12px;
        box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
        padding: 8px;
      }
      .team {
        font-size: 16px;
        line-height: 16px;
        height: 62px;
        color: ${MAIN_BLACK};
      }
    }
  }
`;

export default WPContent;
